import { FC, useContext } from "react"
import { SwapButton} from "../../atoms";
import { SocketContext, TableContext, TeamContext } from "../../../context"
import { useTranslation } from "react-i18next";

interface ISwapCardButton {
    cardType: string;
    isThisJokerButton?: boolean;
}

const SwapCardButton: FC<ISwapCardButton> = (props) => {
    const { cardType, isThisJokerButton } = props;
    const { t } = useTranslation();
    const { game } = useContext(TeamContext)
    const { withdrawCardSocketEvent, skipDillemaCardSocketEvent, activateJokerButtonSocketEvent } = useContext(SocketContext);
    const { setAreAnimatedHandsShown } = useContext(TableContext);
    const { setToggleMySolutionFullScreen } = useContext(TableContext);
    const jokerCardId : number = 1;


    const getTheChallengeJokerCard = () => {
        if (game?.gameInfo?.currentDilemmaCard.id === jokerCardId) {
            alert(t("youAlreadyHaveJockerCardText"))
            return;
        }   
        
        activateJokerButtonSocketEvent();
    }

    const replaceTheChosenChallengeCard = () => {
        skipDillemaCardSocketEvent();
    }

    const replaceThProposedSolutionCard = () => {
        withdrawCardSocketEvent();
        setAreAnimatedHandsShown(true);
        setToggleMySolutionFullScreen(true);
    }

    if (isThisJokerButton)
        return (
            <div style={{ position: "absolute", height: "6vh", bottom: "0vh", right: "1vh", cursor: "pointer" }}>
                <div style={{transform: "scale(1.5)"}}>
                    <SwapButton clickHandler={() => getTheChallengeJokerCard()} isThisJokerButton={true} />
                </div>
            </div>
        )

    if (cardType === "challenge")
        return (
            <div style={{ position: "absolute", top: "1vh", right: "1vh", cursor: "pointer" }}>
                <div style={{transform: "scale(1.5)"}}>
                    <SwapButton clickHandler={() => replaceTheChosenChallengeCard()} />
                </div>
            </div>
        )

    return (
        <div style={{ width: "100%", height: "50px", position: "relative" }}>
            <div className="full_screen center_horizontally_and_vertically" style={{transform: "scale(1.2)"}}>
                <SwapButton isThisReturnButton={true} clickHandler={() => replaceThProposedSolutionCard()} />
            </div>
        </div>
    )
}

export default SwapCardButton;